module.exports = __webpack_public_path__ + "static/media/Jiacheng Li.26fe612a.png";